/** @typedef {'amber' | 'terracotta' | 'sage' | 'neutral'} AppAccent */

/**
 * @typedef {{
 *   id: string,
 *   name: string,
 *   description: string,
 *   category?: 'marketing' | 'leads' | 'payments',
 *   fileName?: string,
 *   slug?: string,
 *   icon?: 'globe' | 'plug' | 'chart' | 'app',
 *   iconUrl?: string,
 *   accent: AppAccent,
 * }} NavApp
 */

/** In-app automation apps pinned in the home sidebar. */
/** @type {NavApp[]} */
const APPS = [
  {
    id: 'app-lead-generation',
    slug: 'lead-generation',
    name: 'Lead generation',
    category: 'leads',
    description: 'Score inbound leads, enrich contacts, and route opportunities to owners',
    icon: 'app',
    accent: 'neutral',
  },
  {
    id: 'app-marketing-automation',
    slug: 'marketing-automation',
    name: 'Marketing automation',
    category: 'marketing',
    description: 'Schedule campaigns, publish content, and notify teams on launch',
    icon: 'app',
    accent: 'neutral',
  },
  {
    id: 'app-payment-reconciliation',
    slug: 'payment-reconciliation',
    name: 'Payment reconciliation',
    category: 'payments',
    description: 'Sync payments, update ledgers, and flag anomalies for finance',
    icon: 'app',
    accent: 'neutral',
  },
]

export default APPS
